import React, { FunctionComponent } from "react";
import { useSelector } from "react-redux";

import { Content, Message, MessageWrapper, StyledContainer, Text, Video } from "./styles";

import { configState } from "state/config-slice";
import getImageUrl from "utils/getImageUrl";
import getOpco from "utils/getOpco";

import theme from "themes/default";
import themeLowi from "themes/lowi";

const Loader: FunctionComponent = () => {
  const {
    loader: { showLoader, messageHeader, messageText },
  } = useSelector(configState);

  const activeTheme = getOpco() === "lw" ? themeLowi : theme;

  return (
    <StyledContainer $isVisible={showLoader}>
      <Content>
        <Video width="300" height="300" autoPlay loop muted playsInline>
          <source src={getImageUrl(activeTheme.customTheme.loader + ".mp4")} type="video/mp4" />
          <source src={getImageUrl(activeTheme.customTheme.loader + ".webm")} type="video/webm" />
        </Video>

        <MessageWrapper>
          {messageHeader && <Message>{messageHeader}</Message>}
          {messageText && <Text>{messageText}</Text>}
        </MessageWrapper>
      </Content>
    </StyledContainer>
  );
};

export default React.memo(Loader);
